var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaCasa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s5pob"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.49h23.881v12.982H8z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#67a2ad",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M11.22 31.173h.082m8.556-17.513l8.677 8.359v9.154h-5.573V24.01h-5.97v7.164h-5.69V22.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s5pob)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M31.039 22.472a.839.839 0 0 1-.59-.24L19.872 11.853 9.434 22.159a.843.843 0 1 1-1.183-1.199L19.869 9.49l11.76 11.539a.842.842 0 0 1-.59 1.443"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaCasa);
export default __webpack_public_path__ + "static/media/IconaCasa.877f7330e7778f701eb91e001159e894.svg";
export { ForwardRef as ReactComponent };